<template>
	<nk-page commercialAccess="System" :policyClaims="['Accounting_FloatingCenters_CategoryManagement']">
		<template #badges>
			<nk-badge system="accounting"></nk-badge>
		</template>
		<div class="nk-card h-100 d-flex flex-column">
			<div class="h-grow-lock">
				<nk-table v-model="selectedRow" @data-changed="dataChanged" :data="categories" :options="tableOptions" ref="catsList" tabindex="101" startup @row_dbClicked="rowDbClicked">
				</nk-table>
			</div>
		</div>
	</nk-page>
</template>
<script>
	import $ from 'jquery'
	import _ from 'lodash'
	import Input from '~/components/general/nikan-input.vue'
	import $sc from '~/plugins/shortcut.collection.js'
	import dialog from '~/plugins/nikan-dialog-plugin'
	import { mapGetters, mapActions } from 'vuex'
	import emptyId from '~/statics/empty-id'
	import validators, { VRequired } from '~/statics/validators'

	export default {
		modal: {
			size: 'lg',
			stateUID: 'floatingCenter-category-selector',
			helpTag: 'FloatingCenterCategory'
		},
		props: {
			data: { type: [Array, Object] },
			options: { type: Object },
		},
		data() {
			return {
				settings: {
					type: null,
					title: null
				},
				localSelectedItem: null,
				selectedRow: null,
				tableOptions: {
					activeRowDisabled: true,
					editable: this.$nikan.checkPermission('Accounting_FloatingCenters_EditCategory'),
					searchable: false,
					allowNewRow: true,
					alwaysEmit: true,
					buttons: {
						addBtn: {
							options: {
								visible: true,
								policyClaims: 'Accounting_FloatingCenters_EditCategory',
							}
						},
						deleteBtn: {
							options: {
								visible: true,
								policyClaims: 'Accounting_FloatingCenters_EditCategory',
							}
						}
					},
					displayOrderEnabled: false,
					prepareNewRow: () => {
						return this.generateEmptyRow()
					},
					defaultSortByCols: [{ name: 'code', type: 'number' }],
					columns: [
						{
							name: 'rowNumber',
							title: this.$t('row-number'),
							searchable: true,
							sortable: true,
							editable: false,
							width: 80,
							entering: false,
							pinned: true,
							pinnable: false,
							resizable: false,
						},
						{
							name: 'code',
							title: this.$t('category.f.code'),
							edit: {
								component: Input,
								options: {
									mode: 'strnumber',
								},
							},
							searchable: true,
							sortable: false,
							editable: true,
							validators: validators('required'),
							width: '80px',
						},
						{
							name: 'name',
							title: this.$t('category.f.name'),
							edit: {
								component: Input,
								options: {
									mode: 'string',
								},
							},
							searchable: true,
							sortable: false,
							editable: true,
							width: 100,
							validators: validators(new VRequired()),
						},
						{
							name: 'allowedOpenFactorsCount',
							title: this.$t('category.f.allowedOpenFactorsCount'),
							edit: {
								component: Input,
								options: {
									mode: 'integer',
								},
							},
							searchable: true,
							sortable: false,
							editable: true,
							width: 120,
						},
						{
							name: 'allowedDailyFactorsCount',
							title: this.$t('category.f.allowedDailyFactorsCount'),
							edit: {
								component: Input,
								options: {
									mode: 'integer',
								},
							},
							searchable: true,
							sortable: false,
							editable: true,
							width: 120,
						},
						{
							name: 'pendingChequesCount',
							title: this.$t('category.f.pendingChequesCount'),
							edit: {
								component: Input,
								options: {
									mode: 'integer',
								},
							},
							searchable: true,
							sortable: false,
							editable: true,
							width: 120,
						},
						{
							name: 'pendingChequesAmount',
							title: this.$t('category.f.pendingChequesAmount'),
							type: 'price',
							view: {
								options: {
									type: 'price',
								},
							},
							edit: {
								component: Input,
								options: {
									mode: 'price',
									useDefaultValue: true,
								},
							},
							editable: true,
							width: '150px',
							entering: true,
						},
						{
							name: 'bouncedChequesCount',
							title: this.$t('category.f.bouncedChequesCount'),
							edit: {
								component: Input,
								options: {
									mode: 'integer',
								},
							},
							searchable: true,
							sortable: false,
							editable: true,
							width: 120,
						},
						{
							name: 'bouncedChequesAmount',
							title: this.$t('category.f.bouncedChequesAmount'),
							type: 'price',
							view: {
								options: {
									type: 'price',
								},
							},
							edit: {
								component: Input,
								options: {
									mode: 'price',
									useDefaultValue: true,
								},
							},
							editable: true,
							width: '150px',
							entering: true,
						},
						{
							name: 'allowedFactorCheckoutDays',
							title: this.$t('category.f.allowedFactorCheckoutDays'),
							edit: {
								component: Input,
								options: {
									mode: 'integer',
								},
							},
							searchable: true,
							sortable: false,
							editable: true,
							width: 120,
						},
					],
				},
				pageButtons: {
					saveButton: {
						title: this.$t('save'),
						shortcut: $sc.find('save'),
						icon: 'save',
						visible: true,
						disabled: true,
						isPrimary: true,
						handle: (button, page, e) => {
							this.save().then((res) => {
								this.$nikan.formUtility.switchMode(this.pageButtons, 'select')
								this.$refs.catsList.table_Focused()
								this.defer(() => this.$refs.catsList.$el.focus(), 10)
							})
						},
						policyClaims: 'Accounting_FloatingCenters_EditCategory',
					},
					selectButton: {
						title: this.$t('select'),
						shortcut: $sc.find('save'),
						icon: 'check',
						visible: (this.options || {}).selectable,
						disabled: false,
						isPrimary: true,
						handle: (button, page, e) => {
							if (_.isEmpty(this.selectedRow))
								return this.$toast(this.$t('document.m.select-row'))

							this.resolve(this.selectedRow)
						},
						policyClaims: 'Accounting_FloatingCenters_CategoryManagement',
					},
				}
			}
		},
		computed: {
			...mapGetters({
				category_all: 'floatingCenterCategories/all',
				category_type: 'floatingCenterCategories/allInType',
			}),
			categories() {
				const cats = () => {
					if (this.settings.type == null) {
						return this.category_all
					} else {
						return this.category_type(this.settings.type)
					}
				}
				let cloned = _.cloneDeep(cats())
				return cloned
			},
		},
		watch: {
			options: {
				immediate: true,
				deep: true,
				handler(val) {
					this.settings = _.merge(this.settings, val)
				},
			},
		},
		created() {
			this.localSelectedItem = this.data
		},
		mounted() {
			let buttonsArray = [
				this.pageButtons.selectButton,
				this.pageButtons.saveButton,
			]

			this.prepareWindow(this.$t('category.list', {
				type: this.$t('category.' + 'floatingcenter'),
			}), buttonsArray)
		},
		methods: {
			dataChanged() {
				this.$nikan.formUtility.switchMode(this.pageButtons, 'edit')
			},
			...mapActions({
				category_modify: 'floatingCenterCategories/modify',
			}),
			isTableChanged(datas) {
				if (datas.findIndex((data) => data.rowState !== 'unchanged') > -1) return true
				else
					this.$toast(this.$t('category.m.save.table-unchanged'), { type: 'info' })
			},
			generateEmptyRow() {
				return {
					code: '',
					type: this.settings.type,
					companyId: emptyId,
					allowedOpenFactorsCount: 0,
					allowedDailyFactorsCount: 0,
					pendingChequesCount: 0,
					pendingChequesAmount: 0,
					bouncedChequesCount: 0,
					bouncedChequesAmount: 0,
					allowedFactorCheckoutDays: 0,
				}
			},
			save() {
				var that = this

				return new Promise((resolve, reject) => {
					this.$refs.catsList
						.commitChanges()
						.then((categories) => {
							if (this.isTableChanged(categories)) {
								this.category_modify(categories).then((categories) => {
									this.$toast(this.$t('category.m.save.success'), { type: 'success' })
									resolve(categories)
								})
							}
						})
						.catch((errorRows) => {
							if ($.isArray(errorRows)) {
								var rowNumbers = errorRows.map((x, i) => x.rowNumber).join(',')
								dialog({
									title: this.$t('category.m.save-category-title'),
									body: this.$t('category.m.save.error.rows', { rowNumbers }),
									type: 'error',
									isPrimary: true,
								})
							} else {
								dialog({
									title: this.$t('category.m.save-category-title'),
									body: errorRows.message,
									type: 'error',
									isPrimary: true,
								})
							}

							reject(new Error('invalid-rows'))
							that.defer(() => that.$refs.catsList.$el.focus(), 100)
						})
				})
			},
			rowDbClicked(val) {
				if (this.grandParentType() === 'modal')
					this.resolve(val)
			}
		},
	}
</script>
<style></style>
